// extracted by mini-css-extract-plugin
module.exports = {"my-lottie":"LottieAnimation_my-lottie__MZK41"};